import React from 'react';
import '../styles/node-stats.css';

const NodeStats = () => {
  // Node statistics data - this will be replaced with API data
  const nodeStats = [
    {
      title: 'Active Nodes',
      value: '2,847',
      change: '+15%',
      positive: true,
      comingSoon: true,
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17 21V19C17 16.7909 15.2091 15 13 15H5C2.79086 15 1 16.7909 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M23 21V19C22.9986 17.1771 21.765 15.5857 20 15.13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 3.13C17.7699 3.58317 19.0078 5.17799 19.0078 7.005C19.0078 8.83201 17.7699 10.4268 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Staked AFI',
      value: '689.4M',
      change: '+8.5%',
      positive: true,
      comingSoon: true,
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 7L12 3L4 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M4 7V17L12 21L20 17V7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 11L20 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 11V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 11L4 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Avg. Team Size',
      value: '32',
      change: '+12%',
      positive: true,
      comingSoon: true,
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M23 21V19C23 17.9391 22.5786 16.9217 21.8284 16.1716C21.0783 15.4214 20.0609 15 19 15H15C13.9391 15 12.9217 15.4214 12.1716 16.1716C11.4214 16.9217 11 17.9391 11 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M17 11C19.2091 11 21 9.20914 21 7C21 4.79086 19.2091 3 17 3C14.7909 3 13 4.79086 13 7C13 9.20914 14.7909 11 17 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M9 21V19C9 17.9391 8.57857 16.9217 7.82843 16.1716C7.07828 15.4214 6.06087 15 5 15H1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M5 11C7.20914 11 9 9.20914 9 7C9 4.79086 7.20914 3 5 3C2.79086 3 1 4.79086 1 7C1 9.20914 2.79086 11 5 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Governance Votes',
      value: '437',
      change: '+3.8%',
      positive: true,
      comingSoon: true,
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 11H5C3.89543 11 3 11.8954 3 13V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M7 11V7C7 5.93913 7.42143 4.92172 8.17157 4.17157C8.92172 3.42143 9.93913 3 11 3H13C14.0609 3 15.0783 3.42143 15.8284 4.17157C16.5786 4.92172 17 5.93913 17 7V11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="12" cy="16" r="1" fill="currentColor"/>
        </svg>
      )
    }
  ];

  // Node Tier distributions (percentages)
  const tierDistribution = [
    { name: 'Standard Nodes', percentage: 65, color: 'var(--primary)' },
    { name: 'Super Nodes', percentage: 20, color: 'var(--secondary)' },
    { name: 'Master Nodes', percentage: 10, color: 'var(--accent)' },
    { name: 'Apex Nodes', percentage: 5, color: 'var(--warning)' }
  ];

  return (
    <section className="node-stats" id="node-stats">
      <div className="container">
        <h2 className="section-title">Node <span>Network Statistics</span></h2>
        <p className="section-subtitle">
          Our decentralized node system is continuously growing, with team leaders from around the world joining the Aledger ecosystem.
        </p>
        
        <div className="data-coming-soon">
          <p>Complete node network statistics will be available soon. The data shown below is preliminary.</p>
        </div>
        
        <div className="stats-grid">
          {nodeStats.map((stat, index) => (
            <div className="stat-card" key={index}>
              <div className="stat-icon">{stat.icon}</div>
              <div className="stat-info">
                <h3 className="stat-title">{stat.title}</h3>
                {stat.comingSoon ? (
                  <div className="stat-coming-soon">
                    <div className="stat-placeholder-value"></div>
                    <div className="stat-placeholder-change"></div>
                    <div className="coming-soon-label">Data coming soon</div>
                  </div>
                ) : (
                  <>
                    <div className="stat-value">{stat.value}</div>
                    <div className={`stat-change ${stat.positive ? 'positive' : 'negative'}`}>
                      {stat.change} last 30 days
                      <span className="change-icon">
                        {stat.positive ? (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 19V5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M5 12L12 5L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        ) : (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 5V19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M19 12L12 19L5 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        )}
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
        
        <div className="distribution-section">
          <h3 className="distribution-title">Node Tier Distribution</h3>
          
          <div className="tier-distribution">
            <div className="distribution-visual">
              <div className="distribution-chart">
                {tierDistribution.map((tier, index) => (
                  <div
                    key={index}
                    className="chart-segment"
                    style={{
                      width: `${tier.percentage}%`,
                      backgroundColor: tier.color
                    }}
                    title={`${tier.name}: ${tier.percentage}%`}
                  ></div>
                ))}
              </div>
              <div className="distribution-labels">
                {tierDistribution.map((tier, index) => (
                  <div 
                    key={index} 
                    className="tier-label" 
                    style={{ left: `${getTierLabelPosition(tierDistribution, index)}%` }}
                  >
                    {tier.percentage}%
                  </div>
                ))}
              </div>
            </div>
            
            <div className="distribution-legend">
              {tierDistribution.map((tier, index) => (
                <div className="legend-item" key={index}>
                  <div className="legend-color" style={{ backgroundColor: tier.color }}></div>
                  <div className="legend-text">
                    <strong>{tier.name}</strong>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className="node-benefits">
          <h3 className="benefits-title">Key Benefits of Becoming a Node Operator</h3>
          
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17 9V7C17 5.89543 16.1046 5 15 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19H7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9 15H19C20.1046 15 21 14.1046 21 13V9C21 7.89543 20.1046 7 19 7H9C7.89543 7 7 7.89543 7 9V13C7 14.1046 7.89543 15 9 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <circle cx="19" cy="11" r="1" fill="currentColor"/>
                </svg>
              </div>
              <h4>Passive Income</h4>
              <p>Earn consistent income through a percentage of mining rewards from all devices in your team, plus commissions on device sales.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9 21V12H15V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>Build Your Community</h4>
              <p>Create and manage your own team of users, helping them succeed while expanding your node's reach and impact.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 6.65685 16.3431 8 18 8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M6 15C7.65685 15 9 13.6569 9 12C9 10.3431 7.65685 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M18 22C19.6569 22 21 20.6569 21 19C21 17.3431 19.6569 16 18 16C16.3431 16 15 17.3431 15 19C15 20.6569 16.3431 22 18 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8.59 13.51L15.42 17.49" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M15.41 6.51L8.59 10.49" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>Network Influence</h4>
              <p>Participate in governance voting with weighted votes based on your node level, helping shape the future of the Aledger ecosystem.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18457 2.99721 7.13633 4.39828 5.49707C5.79935 3.85782 7.69279 2.71538 9.79619 2.24015C11.8996 1.76491 14.1003 1.98234 16.07 2.86" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4>Growth Opportunities</h4>
              <p>Start at Level 1 and progress through the node hierarchy as your team expands, unlocking higher rewards and additional privileges.</p>
            </div>
          </div>
        </div>
        
        <div className="cta-container">
          <a href="#node-application" className="btn">Apply for Node Operator Status</a>
        </div>
      </div>
    </section>
  );
};

// Helper function to calculate the position of tier labels
function getTierLabelPosition(tiers, index) {
  let position = 0;
  for (let i = 0; i <= index; i++) {
    if (i === index) {
      position += tiers[i].percentage / 2;
    } else {
      position += tiers[i].percentage;
    }
  }
  return position;
}

export default NodeStats;
